<template>
	<div class="innerPage">
		<div class="tab-content" v-if="userVerified">
			<div
				role="tabpanel"
				aria-hidden="false"
				class="fade tab-pane active show"
			>
				<div class="pageAssetsList">
					<div class="titleContainer">
						<h1 class="title">קבלת עדכונים על נכסים</h1>
						<p class="plainText">
							רוצים להתעדכן בכל מה שקורה סביב הבית שלכם או סביבה שמסקרנת
							אתכם?<br />
							הרשמו לקבלת עדכונים ואנחנו נדאג להשאיר אתכם מעודכנים
						</p>
					</div>
					<!-- <div class="searchContainer">
						<div class="searchRow addAutosuggest">
							<div class="searchAutosuggest">
								<div
									role="combobox"
									aria-haspopup="listbox"
									aria-owns="react-autowhatever-1"
									aria-expanded="false"
									class="react-autosuggestcontainer"
								>
									<input
										id="myInput_addr"
										v-model="$store.state.addr_comp_search"
										type="text"
										autocomplete="on"
										aria-autocomplete="list"
										aria-controls="react-autowhatever-1"
										class="react-autosuggest__input"
										style="margin-bottom: 30px"
										placeholder="חפשו את הכתובת עליה תרצו עדכונים"
									/>
									<div
										id="react-autowhatever-1"
										role="listbox"
										class="react-autosuggestsuggestions-container"
									></div>
								</div>
								<div class="magnifyWrap">
									<svg
										width="24px"
										height="24px"
										viewBox="0 0 24 24"
										version="1.1"
										class="magnifyIcon"
									>
										<title>search</title>
										<g
											id="search-24"
											stroke="none"
											stroke-width="1"
											fill="none"
											fill-rule="evenodd"
										>
											<rect
												id="Rectangle"
												x="0"
												y="0"
												width="24"
												height="24"
											></rect>
											<path
												d="M18.0104076,15.5104076 L21.0104076,15.5104076 L21.0104076,22.0104076 C21.0104076,22.8388348 20.3388348,23.5104076 19.5104076,23.5104076 C18.6819805,23.5104076 18.0104076,22.8388348 18.0104076,22.0104076 L18.0104076,15.5104076 L18.0104076,15.5104076 Z"
												id="Rectangle-hand"
												fill="#000000"
												transform="translate(19.510408, 19.510408) rotate(-45.000000) translate(-19.510408, -19.510408)"
											></path>
											<circle
												id="Oval"
												stroke="#000000"
												stroke-width="2"
												cx="10.5"
												cy="10.5"
												r="8.5"
											></circle>
										</g>
									</svg>
								</div>
								<button v-if="$store.state.addr_comp_search != ''" @click="$store.state.addr_comp_search = ''"
									class="deleteTextIcon show"
									aria-label="מחיקת הטקסט בשורת חיפוש והתחלה מחדש"
								>
									<img
										class="icon"
										src="/images/autosuggestCloseIcon.png"
										alt=""
									/>
								</button>
								<div class="submitBtnWrapper">
									<button
										@click="addAddress()"
										type="submit"
										class="btn arrowBtn plusBtn"
									>
										<span class="plus"></span>
									</button>
								</div>
							</div>
						</div>
						<div style="text-align: center; height: 21.97px">
							<p style="color: red" class="plainText">{{ errorText }}</p>
						</div>
					</div> -->

					<SearchBoxUserAddresses></SearchBoxUserAddresses>

					<div class="container-fluid">
						<div class="whiteContainer">
							<div class="titleContainer">
								<h2 class="title">רשימת הנכסים</h2>
								<p class="plainText">
									קיימת אפשרות לשמור עד 6 נכסים ({{
										$store.state.currentUser.addressList.length
									}}/6)
								</p>
							</div>
							<ul class="listAssets">
								<li
									v-for="(address, index) in $store.state.currentUser.addressList"
									:key="index"
									class="assetItem"
								>
									<h2 class="title">{{ address.addressName }} {{ getAddressType(address.addressType) }}</h2>
									<div class="btnsAsset">
										<button @click="removeAddress(address)" class="deleteIcon">
											<img
												class="icon"
												src="/images/autosuggestCloseIcon.png"
												alt=""
											/><span>הסרה</span>
										</button>
										<button
											@click="updateUrl(address.addressId, address.addressType)"
											class="btn blue"
										>
											מעבר לנכס
										</button>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SearchBoxUserAddresses from "./SearchBoxUserAddresses.vue";
export default {
	name: "UserAddresses",
	components: {
		SearchBoxUserAddresses,
	},
	data() {
		return {
			member: "Member",
			addrToAdd: null,
			errorText: "",
		};
	},
	computed: {
		userVerified() {
			if (this.$store.state.currentUser == null) 
			{
				return false;
			}
			else {
				return this.$store.state.currentUser.Verified;
			}
		}
	},
	mounted() {
		var appVue = this;
		this.$store.state.currentUser = this.decompressBase64Gzip(this.mixin_getCookie('user'));
		//console.log('currentUser from userAddresses', this.$store.state.currentUser);
		//this.$store.state.currentUser = unzip(user_zip);
		//console.log('currentUser', this.$store.state.currentUser);
		if (this.$store.state.currentUser == null) {
			this.mixin_goTo(this, "login");
		}
		if (appVue.$store.state.neigh == null) {
			appVue.$store.dispatch("loadNeigh");
		}
		// decompress and get cookieObject.prototype.hasOwnProperty.call(userData , "addressList")
		var decompressed =  this.decompressBase64Gzip(this.mixin_getCookie('user'));
		const userData = decompressed;
		if (Object.prototype.hasOwnProperty.call(userData , "addressList") == false){
			// add addressList
			//userData.addressList = [];
			this.mixin_removeCookie('user');
			// compress and set cookie
			var compressed = this.compressBase64Gzip(JSON.stringify(userData));
			this.mixin_setCookie('user', compressed );
		}

		if (this.$store.state.currentUser == null || Object.prototype.hasOwnProperty.call(this.$store.state.currentUser, "addressList") == false) {
			this.$store.state.currentUser.addressList = [];
		}

		//var inputElement = document.getElementById("myInput_addr");
		//this.mixin_setSearchBox(this, inputElement);

		//get the addresses
		appVue
			.mixin_getData(
				appVue,
				appVue.$store.state.currentUser.useremail,
				appVue.$store.state.currentUser.userid,
			)
			.then((addresses_res) => {
				if (addresses_res.statusCode == 200) {
					
					appVue.$store.state.addr_comp_search = "";
					if (addresses_res.data.address == null) {
						appVue.$store.state.currentUser.addressList = [];
					} else {
						appVue.$store.state.currentUser.addressList =
							addresses_res.data.address;
					}
					//appVue.mixin_setSearchBox(appVue, inputElement);
				}
			});

		// document
		// 	.getElementById("myInput_addr")
		// 	.addEventListener("keydown", function () {
		// 		appVue.errorText = "";
		// 		// Check if the key pressed is the Enter key (key code 13)
		// 		// remove streets 10 times each 0.5 seconds
		// 		var x = 0;
		// 		var interval = setInterval(function () {
		// 			appVue.removeStreets();
		// 			x++;
		// 			if (x === 100) {
		// 				clearInterval(interval);
		// 			}
		// 		}, 2000);
		// 	});
	},
	methods: {
		getAddressType(addressType){
			if (addressType == "NEIGHBORHOOD"){
				return ", שכונה"
			}
			if (addressType == "STREET"){
				return ", רחוב"
			}
			if (addressType == "ADDRESS"){
				return ", כתובת"
			}
			return ""
		},
		removeAddress(address) {
			
			var index = this.$store.state.currentUser.addressList.indexOf(address);
			if (index > -1) {
				this.$store.state.currentUser.addressList.splice(index, 1);
			}
			this.currentUser = this.$store.state.currentUser;
			this.mixin_removeCookie('user');
			// compress and set cookie
			var compressed = this.compressBase64Gzip(JSON.stringify(this.$store.state.currentUser));
			this.mixin_setCookie('user', compressed);
			this.mixin_updateData(
				this,
				this.$store.state.currentUser.addressList,
				this.$store.state.currentUser.useremail,
				this.$store.state.currentUser.userid,
			).then(() => {
				this.mixin_removeCookie('user');
				// compress and set cookie
				var compressed = this.compressBase64Gzip(JSON.stringify(this.$store.state.currentUser));
				this.mixin_setCookie('user', compressed);

			});
		},
		removeStreets() {
			var items = document.querySelectorAll(
				"#myInput_addrautocomplete-list > div [data-lyr]",
			);
			for (var i = 0; i < items.length + 1; i++) {
				var a = document.querySelector(
					"#myInput_addrautocomplete-list > div:nth-child(" + i + ")",
				);
				if (a != null) {
					if (a.childNodes[2].dataset.lyr == "SETTLEMENT" || a.childNodes[2].dataset.lyr == "KPARCEL_ALL") {
						//
						a.remove();
					}
				}
			}
		},
		addAddress() {
			this.errorText = "";
			var address = this.addrToAdd;
			if (address != null && address != "") {
				//
				// check if the address id is already in the list of objects..'
				var addr_id = address.addressId;
				var addr_ids = this.$store.state.currentUser.addressList.map(
					(a) => a.addressId,
				);
				
				if (addr_ids.length >= 6) {
					//this.$store.dispatch('addAddress', address);
					this.errorText = "ניתן לשמור עד 6 כתובות";
					return;
				} else if (
					this.$store.state.addr_comp_search == null ||
					this.$store.state.addr_comp_search == "" ||
					this.$store.state.addr_comp_search == undefined
				) {
					this.errorText = "נא להזין כתובת";
					return;
				} else if (addr_ids.includes(addr_id)) {
					this.errorText = "כתובת זו כבר קיימת ברשימה";
					return;
				} else {
					
					this.$store.state.currentUser.addressList.push(this.addrToAdd);
					this.$store.state.addr_comp_search = "";
					this.mixin_updateData(
						this,
						this.$store.state.currentUser.addressList,
						this.$store.state.currentUser.useremail,
						this.$store.state.currentUser.userid,
					).then(() => {
						this.mixin_removeCookie('user');
						//compress and set cookie
						var compressed = this.compressBase64Gzip(JSON.stringify(this.$store.state.currentUser));
						this.mixin_setCookie('user', compressed);
					});
				}
				this.currentUser = this.$store.state.currentUser;
			}
			this.mixin_removeCookie('user');
			// compress and set cookie
			var compressed = this.compressBase64Gzip(JSON.stringify(this.$store.state.currentUser));
			this.mixin_setCookie('user', compressed);
		},

		updateUrl(addressId, addressType) {
			//if (this.$route.params.addressId != addressId) {
			if (this.$route.query.id != addressId) {
				const origin = window.location.origin;
				const target = "view="+addressType.toLowerCase()+"&id=" + addressId + "&page=deals";
				// redirect to origin + target
				window.location.href = origin + "/?" + target;
				setTimeout(() => {
					//go to top
					window.scrollTo(0, 0);
				}, 1);
			}
		},
	},
};
</script>

<style scoped>
#myInput_addrautocomplete-list > div[data-lyr="STREET"] {
	/* Your CSS rules here */
	display: none !important;
}
</style>
